import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
import Link from "../../Link/Link/Link.js";
/* empty css               */
const LinkLists = ({ className, items, ...rest }) => /* @__PURE__ */ React.createElement("div", { className: classnames("link-lists", className), ...rest }, items.map((column, index) => /* @__PURE__ */ React.createElement("div", { className: "link-lists__column", key: column.id ?? (column.title || `item-${index}`) }, column.title && /* @__PURE__ */ React.createElement(Text, { className: "link-lists__text", component: "h2" }, column.title), column.links.map((link, index2) => /* @__PURE__ */ React.createElement(
  Link,
  {
    key: link.id ?? (link.label || `column-item-${index2}`),
    className: "link-lists__link",
    ...link
  }
)))));
export {
  LinkLists as default
};
//# sourceMappingURL=LinkLists.js.map
